/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { ISageTransportParams, SageTransport } from '@tivocorp/tivo-webapp-loggers';
import { DeviceModel } from '../device/DeviceModel';
import { MEDIA_HEALTH_EVENTS_INTERVAL, SAGE_BASE_URL, SAGE_LOGGING_VERSION } from '../../config';

export class SageLogger {
    private static sageParams: ISageTransportParams = {
        appName: 0xc, // Kaveri - Application on SmartTVs (other than Oyster)
        developmentPhase: DeviceModel.getAppEnvironment() === 'production' ? 0x3 : 0x1, // Development - Debug builds
        device: 0x6, // SmartTV
        deviceFamily: 0x6, // SmartTV
        hecEndpoint: '',
        loggingVersion: SAGE_LOGGING_VERSION,
        mediaHealthEventsInterval: MEDIA_HEALTH_EVENTS_INTERVAL,
        os: 0x5,
        partnerId: 1111, // It is a TIVO test development.
        tokenSalt: '',
    };

    private static mDiagnosticsSageTransport: SageTransport;

    private static mOperationsSageTransport: SageTransport;

    private static getSageBaseUrl = (): string => {
        // TODO read form SLS
        return SAGE_BASE_URL;
    };

    static initDiagnosticsSageTransport() {
        SageLogger.sageParams.hecEndpoint = SageLogger.getSageBaseUrl();
        SageLogger.sageParams.tokenSalt = 'Sage1D:';
        SageLogger.sageParams.partnerId = Number(
            DeviceModel.getTiVoSettings().getMsoPartnerId()?.split('.')[1],
        );
        SageLogger.mDiagnosticsSageTransport = new SageTransport(SageLogger.sageParams);
    }

    static initOperationsSageTransport() {
        SageLogger.sageParams.hecEndpoint = SageLogger.getSageBaseUrl();
        SageLogger.sageParams.tokenSalt = 'Sage1O:';
        SageLogger.sageParams.partnerId = Number(
            DeviceModel.getTiVoSettings().getMsoPartnerId()?.split('.')[1],
        );
        SageLogger.mOperationsSageTransport = new SageTransport(SageLogger.sageParams);
    }

    static getDiagnosticsTransport() {
        if (!SageLogger.mDiagnosticsSageTransport) SageLogger.initDiagnosticsSageTransport();
        return SageLogger.mDiagnosticsSageTransport;
    }

    static getOperationsTransport() {
        if (!SageLogger.mOperationsSageTransport) SageLogger.initOperationsSageTransport();
        return SageLogger.mOperationsSageTransport;
    }
}
